import store from "@/store";
import User from "@/Models/User";
import { $loaderService } from "@/plugins/ELoaderService";

import MeusPontosPage from "@/Pages/Colaboradores/MeusPontosPage.vue";
import ColaboradoresPontosAdminPage from "@/Pages/Colaboradores/ColaboradoresPontosAdminPage.vue";
import FaltaJustificadaPage from "@/Pages/Colaboradores/FaltaJustificadaPage.vue";
import NovaFaltaJustificadaPage from "@/Pages/Colaboradores/NovaFaltaJustificadaPage.vue";
import GerenciarFaltasJustificadasPage from "@/Pages/Colaboradores/GerenciarFaltasJustificadasPage.vue";
import JustificativaMassaPage from "@/Pages/Colaboradores/JustificativaMassaPage.vue";
import NovaJustificativaMassaPage from "@/Pages/Colaboradores/NovaJustificativaMassaPage.vue";
import FeriadosPage from "@/Pages/Feriados/FeriadosPage.vue";

async function carregarUsuarioSeNecessario() {
  let currentUser = store.getters["Auth/user"];
  if (!currentUser) {
    await $loaderService.loadBasicDataIfNeeded();
    currentUser = store.getters["Auth/user"];
  }
  return currentUser;
}

function temPermissao(permissao) {
  const user = store.getters["Auth/user"];
  if (!user) return false;

  const userInstance = new User({ ...user });
  if (userInstance.hasPermission(permissao)) {
    return true;
  }

  const roleName = user.roleName || (user.roles && user.roles[0] ? user.roles[0].name : "");
  const isGestor = [
    "admin",
    "super-admin",
    "TI",
    "coordenador",
    "direção",
    "secretario-municipal-educacao",
    "secretario",
  ].includes(roleName);

  if (isGestor) {
    return true;
  }

  if (
    permissao === "colaboradores.meusPontos" ||
    permissao === "colaboradores.faltasJustificadas.solicitar"
  ) {
    return true;
  }

  return false;
}

async function redirecionarSemColaborador(to, from, next) {
  const user = await carregarUsuarioSeNecessario();
  if (!user) return next({ name: "login" });
  if (temPermissao("colaboradores.meusPontos") || user.colaborador?.id || user.id) {
    return next();
  }
  return next({ name: "home" });
}

async function redirecionarSemPermissaoGestor(to, from, next) {
  const user = await carregarUsuarioSeNecessario();
  if (!user) return next({ name: "login" });
  if (temPermissao("colaboradores.pontos")) {
    return next();
  }
  return next({ name: "home" });
}

async function redirecionarSemPermissaoFaltaJustificada(to, from, next) {
  const user = await carregarUsuarioSeNecessario();
  if (!user) return next({ name: "login" });
  if (temPermissao("colaboradores.faltasJustificadas.solicitar")) {
    return next();
  }
  return next({ name: "home" });
}

async function redirecionarSemPermissaoGestorFalta(to, from, next) {
  const user = await carregarUsuarioSeNecessario();
  if (!user) return next({ name: "login" });
  if (temPermissao("colaboradores.faltasJustificadas.gerenciar")) {
    return next();
  }
  return next({ name: "home" });
}

async function redirecionarSemPermissaoFeriado(to, from, next) {
  const user = await carregarUsuarioSeNecessario();
  if (!user) return next({ name: "login" });
  if (temPermissao("feriados.gerenciar")) {
    return next();
  }
  return next({ name: "home" });
}

async function redirecionarSemPermissaoJustificativaMassa(to, from, next) {
  const user = await carregarUsuarioSeNecessario();
  if (!user) return next({ name: "login" });
  if (temPermissao("colaboradores.justificativaMassa")) {
    return next();
  }
  return next({ name: "home" });
}

export default [
  {
    path: "/colaboradores/meus-pontos",
    name: "colaboradores.meusPontos",
    title: "Meus Pontos",
    component: MeusPontosPage,
    beforeEnter: redirecionarSemColaborador,
  },
  {
    path: "/colaboradores/pontos",
    name: "colaboradores.pontos",
    title: "Ponto dos Colaboradores",
    component: ColaboradoresPontosAdminPage,
    beforeEnter: redirecionarSemPermissaoGestor,
  },
  {
    path: "/colaboradores/faltas-justificadas",
    name: "colaboradores.faltasJustificadas",
    title: "Faltas Justificadas",
    component: FaltaJustificadaPage,
    beforeEnter: redirecionarSemPermissaoFaltaJustificada,
  },
  {
    path: "/colaboradores/faltas-justificadas/nova",
    name: "colaboradores.faltasJustificadas.nova",
    title: "Nova Falta Justificada",
    component: NovaFaltaJustificadaPage,
    beforeEnter: redirecionarSemPermissaoFaltaJustificada,
  },
  {
    path: "/colaboradores/faltas-justificadas/gerenciar",
    name: "colaboradores.faltasJustificadas.gerenciar",
    title: "Gerenciar Faltas Justificadas",
    component: GerenciarFaltasJustificadasPage,
    beforeEnter: redirecionarSemPermissaoGestorFalta,
  },
  {
    path: "/admin/feriados",
    name: "feriados.gerenciar",
    title: "Gestão de Feriados",
    component: FeriadosPage,
    beforeEnter: redirecionarSemPermissaoFeriado,
  },
  {
    path: "/colaboradores/justificativas-massa",
    name: "colaboradores.justificativaMassa",
    title: "Justificativas em Massa",
    component: JustificativaMassaPage,
    beforeEnter: redirecionarSemPermissaoJustificativaMassa,
  },
  {
    path: "/colaboradores/justificativas-massa/nova",
    name: "colaboradores.justificativaMassa.nova",
    title: "Nova Justificativa em Massa",
    component: NovaJustificativaMassaPage,
    beforeEnter: redirecionarSemPermissaoJustificativaMassa,
  },
];
